import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "heading", "grid"]

  connect() {
    this.resolveCallback = null
  }

  show(images, entityName) {
    return new Promise((resolve) => {
      this.resolveCallback = resolve

      if (this.hasHeadingTarget) {
        this.headingTarget.textContent = `Choose a photo for "${entityName}"`
      }

      this.gridTarget.innerHTML = this.buildGrid(images)

      this.dialogTarget.showModal()
      document.body.style.overflow = "hidden"
    })
  }

  formatSource(source) {
    const labels = {
      wikipedia: "Wikipedia",
      wikimedia_commons: "Wikimedia",
      open_library: "Open Library"
    }
    return labels[source] || source || ""
  }

  buildGrid(images) {
    const items = images.map((image, index) => {
      const label = this.escapeHtml(image.label || image.source || "")
      const source = this.escapeHtml(this.formatSource(image.source))
      return `
        <button type="button"
                data-action="photo-picker#selectPhoto"
                data-photo-index="${index}"
                class="group flex flex-col items-center gap-1.5 p-2 rounded-xl border border-gray-200 hover:border-amber-400 hover:bg-amber-50/50 transition-all cursor-pointer focus:outline-none focus:ring-2 focus:ring-amber-400">
          <div class="w-24 h-24 rounded-lg overflow-hidden bg-beige-100 flex items-center justify-center">
            <img src="${this.escapeHtml(image.url)}"
                 alt="${label}"
                 class="w-full h-full object-cover"
                 loading="lazy"
                 onerror="this.parentElement.innerHTML='<span class=\\'text-beige-400 text-xs\\'>Failed</span>'">
          </div>
          <span class="text-xs text-beige-500 text-center truncate w-full">${source}</span>
        </button>
      `
    }).join("")

    return `<div class="grid grid-cols-3 sm:grid-cols-4 gap-3">${items}</div>`
  }

  selectPhoto(event) {
    const index = parseInt(event.currentTarget.dataset.photoIndex, 10)
    this.close()
    if (this.resolveCallback) {
      this.resolveCallback(index)
      this.resolveCallback = null
    }
  }

  cancel() {
    this.close()
    if (this.resolveCallback) {
      this.resolveCallback(null)
      this.resolveCallback = null
    }
  }

  close() {
    this.dialogTarget.close()
    document.body.style.overflow = ""
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.cancel()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.dialogTarget.open) {
      event.preventDefault()
      this.cancel()
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
